import React from 'react';
import { Layout, Lightbulb, Cpu, BookOpen, Users, Video, Megaphone } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  'layout': Layout,
  'lightbulb': Lightbulb,
  'cpu': Cpu,
  'book-open': BookOpen,
  'users': Users,
  'video': Video,
  'megaphone': Megaphone
};

const Services = () => {
  return (
    <section id="servicos" className="section-padding section-bg">
      <div className="container-custom">
        <h2 className="section-title">O que eu faço</h2>
        
        <div className="services-grid">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;